import React, { useState } from "react";
import { IoIosClose } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  deleteOrder,
  deletePayment,
  deletePurchaseOrder,
  updateOrder,
  updatePayment,
  updatePurchaseOrder,
} from "../utils/api";
import { formatDate } from "../utils/formatData";
import Loading from "./Loading";
import CustomModal, { ModalInput, ModalSelect } from "./Modal";
import DeleteModal from "./modals/DeleteModal";
import CustomSelect from "./Select";
import ImageAttachmentModal from "./modals/ImageAttachmentModal";
import useStore from "../utils/store";

const ClientTable = ({
  client,
  data,
  id,
  customer,
  allid,
  all,
  reload,
  customers,
  reload2,
  adminClient,
  isCustomerSection,
}) => {
  const navigate = useNavigate();
  const user = useStore((state) => state.user);
  const [edit, setEdit] = useState(false);
  const [data2, setData2] = React.useState({
    date: new Date(),
  });
  const [loading, setLoading] = React.useState(false);
  const [visibleCount, setVisibleCount] = useState(100);

  React.useEffect(() => {
    setVisibleCount(100);
  }, [id]);

  // Image Attachment & Replacement Modal State
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedRecordForImage, setSelectedRecordForImage] = useState(null);
  const [imageModalField, setImageModalField] = useState("image");
  const [imageModalTitle, setImageModalTitle] = useState("Image");
  const [currentImageForModal, setCurrentImageForModal] = useState("");

  const openImageModal = (item, field, title, currentUrl) => {
    setSelectedRecordForImage(item);
    setImageModalField(field);
    setImageModalTitle(title);
    setCurrentImageForModal(currentUrl || "");
    setImageModalOpen(true);
  };

  const handleRefresh = () => {
    if (reload) reload();
    if (reload2) reload2();
    window.dispatchEvent(new Event("plabel-data-updated"));
    localStorage.setItem("plabel_last_sync", Date.now().toString());
  };

  return (
    <div className="w-full bg-white rounded-xl shadow-xs border border-slate-200 overflow-hidden">
      {loading && <Loading />}
      <div className="w-full overflow-x-auto">
        <table className="w-full border-collapse text-left text-xs">
          <thead>
            <tr className="bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-400 text-slate-900 border-b border-amber-500">
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider whitespace-nowrap">
                Date
              </th>
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider whitespace-nowrap">
                Customer
              </th>
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider whitespace-nowrap">
                Description
              </th>
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider whitespace-nowrap">
                Location
              </th>
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider whitespace-nowrap">
                Product
              </th>
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider text-center whitespace-nowrap">
                Qnt.
              </th>
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider text-center whitespace-nowrap">
                Rate
              </th>
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider text-center whitespace-nowrap">
                GST
              </th>
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider text-center whitespace-nowrap">
                Total
              </th>
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider whitespace-nowrap">
                User
              </th>
              <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider text-center whitespace-nowrap">
                Image
              </th>
              {!customer && (
                <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider text-center whitespace-nowrap">
                  Purchase Image
                </th>
              )}
              {!customer && (
                <th className="border-r border-amber-500/80 px-3 py-2.5 font-extrabold uppercase tracking-wider text-center whitespace-nowrap">
                  Challan
                </th>
              )}

              <th className="px-3 py-2.5 text-center font-extrabold uppercase tracking-wider whitespace-nowrap bg-amber-400">
                <Link
                  to={
                    all
                      ? client
                        ? `/admin/pdf/client/all/${allid}`
                        : `/pdf/customer/all`
                      : client
                      ? `/admin/pdf/client/${id}`
                      : `/pdf/customer/${id}`
                  }
                  replace
                  target="_blank"
                  className="bg-red-600 hover:bg-red-700 active:bg-red-800 text-white text-[10px] font-black px-2 py-0.5 rounded shadow transition active:scale-95 inline-flex items-center gap-0.5"
                >
                  <span>📄</span>
                  <span>PDF</span>
                </Link>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {data?.slice(0, visibleCount).map((item, index) => (
              <tr
                key={item?._id || index}
                className={`transition-colors ${
                  item?.paymentType
                    ? "bg-emerald-50/90 hover:bg-emerald-100/90 text-emerald-950 font-medium"
                    : item?.type === "PurchaseOrder"
                    ? "bg-teal-50/90 hover:bg-teal-100/90 text-teal-950 font-medium"
                    : "hover:bg-slate-50/80 text-slate-800"
                }`}
              >
                {/* 1. Date */}
                <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap">
                  <div className="font-semibold text-slate-800">
                    {formatDate(item?.date)}
                  </div>
                </td>

                {/* 2. Customer */}
                <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap font-bold text-slate-900">
                  {item?.customer?.userName || item?.customer?.name || "-"}
                </td>

                {/* 3. Description */}
                <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap">
                  <span>{item.description || "-"}</span>
                  {item.dispatchNote && (
                    <span className="text-slate-500 font-normal">
                      {`, ${item.dispatchNote}`}
                    </span>
                  )}
                </td>

                {/* 4. Location / City */}
                <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap text-slate-600">
                  {item?.customer?.group?.name || item?.customer?.location || "-"}
                </td>

                {/* 5. Product & 6. Qnt (or Payment Type) */}
                {item?.paymentType ? (
                  <td
                    colSpan={2}
                    className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap"
                  >
                    <span className="bg-emerald-100 text-emerald-900 border border-emerald-300 px-2 py-0.5 rounded font-bold">
                      💳 {item.paymentType}
                    </span>
                  </td>
                ) : (
                  <>
                    <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap font-semibold">
                      {item?.product?.productName || "-"}
                    </td>
                    <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap text-center">
                      <span className="bg-blue-50 text-blue-800 border border-blue-200 px-2 py-0.5 rounded font-mono font-bold">
                        {item.quantity}
                      </span>
                    </td>
                  </>
                )}

                {/* 7. Rate, 8. GST, 9. Total (or Payment Amount) */}
                {item?.paymentType ? (
                  <td
                    colSpan={3}
                    className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap font-mono font-extrabold text-emerald-800"
                  >
                    ₹
                    {item.amount?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                ) : (
                  <>
                    <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap text-center font-mono">
                      {item.rate ? `₹${item.rate}` : "-"}
                    </td>
                    <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap text-center font-mono">
                      {item.gst ? `${item.gst}%` : "-"}
                    </td>
                    <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap text-center font-mono font-bold">
                      ₹
                      {item?.totalAmount?.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || 0}
                    </td>
                  </>
                )}

                {/* 10. User / Staff Name */}
                <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap text-slate-500 font-mono text-[11px]">
                  {item?.completedByName ? (
                    <span>{item.completedByName}</span>
                  ) : item?.completedBy?.person ? (
                    <span>{item.completedBy.person.userName || item.completedBy.person.name || "-"}</span>
                  ) : item?.user ? (
                    <span>{item.user.userName || item.user.name || "-"}</span>
                  ) : (
                    <span>-</span>
                  )}
                </td>

                {/* 11. Image (Sale Order Artwork / Design) */}
                <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap text-center">
                  <div className="flex items-center justify-center gap-1.5">
                    {(() => {
                      // PurchaseOrder image belongs to Purchase Image column, not Sale Image column
                      if (item?.type === "PurchaseOrder" || item?.paymentType) {
                        return <span className="text-slate-400 text-xs">No Image</span>;
                      }
                      const rowImage =
                        item?.image ||
                        item?.customer?.image ||
                        (customers &&
                          customers.find(
                            (c) =>
                              c._id ===
                              (item?.customer?._id || item?.customer || id)
                          )?.image);
                      return rowImage ? (
                        <a
                          href={rowImage}
                          target="_blank"
                          rel="noreferrer"
                          className="text-blue-600 hover:text-blue-800 underline font-semibold text-xs"
                        >
                          View
                        </a>
                      ) : (
                        <span className="text-slate-400 text-xs">No Image</span>
                      );
                    })()}
                  </div>
                </td>

                {/* 12. Purchase Image (From Purchase Tab / Purchase Orders) */}
                {!customer && (
                  <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap text-center">
                    <div className="flex items-center justify-center gap-1.5">
                      {(() => {
                        const rowPurchaseImage =
                          item?.purchaseImage ||
                          (item?.type === "PurchaseOrder" || item?.paymentType === "Payment"
                            ? item?.image
                            : null);
                        return rowPurchaseImage ? (
                          <a
                            href={rowPurchaseImage}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-600 hover:text-blue-800 underline font-semibold text-xs"
                          >
                            View
                          </a>
                        ) : (
                          <span className="text-slate-400 text-xs">
                            No Image
                          </span>
                        );
                      })()}
                    </div>
                  </td>
                )}

                {/* 13. Challan Image */}
                {!customer && (
                  <td className="px-3 py-2 border-r border-slate-200/80 whitespace-nowrap text-center">
                    <div className="flex items-center justify-center gap-1.5">
                      {item?.challanImage ? (
                        <a
                          href={item.challanImage}
                          target="_blank"
                          rel="noreferrer"
                          className="text-blue-600 hover:text-blue-800 underline font-semibold text-xs"
                        >
                          View
                        </a>
                      ) : (
                        <span className="text-slate-400 text-xs">
                          No Image
                        </span>
                      )}
                      {user?.type !== "ViewAdmin" && (
                        <button
                          type="button"
                          onClick={() =>
                            openImageModal(
                              item,
                              "challanImage",
                              "Challan Image",
                              item?.challanImage
                            )
                          }
                          className="text-gray-400 hover:text-blue-600 p-1 rounded hover:bg-gray-100 transition"
                          title={
                            item?.challanImage
                              ? "Replace Challan Image"
                              : "Upload Challan Image"
                          }
                        >
                          ✏️
                        </button>
                      )}
                    </div>
                  </td>
                )}

                {/* 14. Actions */}
                {!isCustomerSection && (
                  <td className="px-3 py-2 whitespace-nowrap text-center">
                    {user?.type !== "ViewAdmin" ? (
                      <div className="flex items-center justify-center gap-1.5">
                        <button
                          type="button"
                          onClick={() => {
                            setData2({
                              ...item,
                              date: item.date,
                              description: item.description,
                              amount: item.amount,
                              quantity: item.quantity,
                              rate: item.rate,
                              gst: item.gst,
                              totalAmount: item.totalAmount,
                              type: item.type,
                            });
                            setEdit(true);
                          }}
                          className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-[11px] px-2.5 py-1 rounded shadow-xs transition active:scale-95 cursor-pointer"
                        >
                          Edit
                        </button>
                        <DeleteModal
                          onClick={async () => {
                            setLoading(true);
                            if (item?.paymentType) {
                              const [success] = await deletePayment(item?._id);
                              if (success) {
                                toast.success("Payment Deleted Successfully");
                                handleRefresh();
                              }
                            } else if (item?.type === "PurchaseOrder") {
                              const [success] = await deletePurchaseOrder(item?._id);
                              if (success) {
                                toast.success("Purchase Order Deleted Successfully");
                                handleRefresh();
                              }
                            } else {
                              const [success] = await deleteOrder(item?._id);
                              if (success) {
                                toast.success("Order Deleted Successfully");
                                handleRefresh();
                              }
                            }
                            setLoading(false);
                          }}
                        >
                          <button
                            type="button"
                            className="bg-red-600 hover:bg-red-700 text-white font-bold text-[11px] px-2 py-1 rounded shadow-xs transition active:scale-95 cursor-pointer"
                          >
                            ✕
                          </button>
                        </DeleteModal>
                      </div>
                    ) : (
                      <span className="text-slate-400 text-xs">-</span>
                    )}
                  </td>
                )}
              </tr>
            ))}
            {(!data || data?.length === 0) && (
              <tr>
                <td
                  className="px-4 py-8 text-center text-slate-400 font-medium text-xs bg-slate-50"
                  colSpan={customer ? 12 : 14}
                >
                  📦 No Records Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Footer */}
      {data?.length > visibleCount && (
        <div className="p-3 bg-slate-50 border-t border-slate-200 flex flex-wrap items-center justify-between gap-2 text-xs text-slate-600">
          <span>
            Showing <strong>{Math.min(visibleCount, data.length)}</strong> of <strong>{data.length}</strong> records
          </span>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => setVisibleCount((prev) => prev + 100)}
              className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold px-3 py-1.5 rounded-lg shadow-2xs transition active:scale-95 cursor-pointer"
            >
              ➕ Load 100 More
            </button>
            <button
              type="button"
              onClick={() => setVisibleCount(data.length)}
              className="bg-slate-200 hover:bg-slate-300 text-slate-800 font-bold px-3 py-1.5 rounded-lg transition active:scale-95 cursor-pointer"
            >
              Show All ({data.length})
            </button>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      <CustomModal
        open={edit}
        setOpen={() => {
          setEdit(false);
          setData2({});
        }}
        onClick={async () => {
          if (data2?.paymentType) {
            const [success] = await updatePayment(data2?._id, {
              ...data2,
              amount: parseFloat(data2.amount),
              date: data2.date,
            });
            if (success) {
              toast.success("Payment Updated");
              handleRefresh();
              setEdit(false);
              setData2({});
            }
            return;
          }

          if (data2?.type === "PurchaseOrder") {
            const [success] = await updatePurchaseOrder(data2?._id, {
              ...data2,
              quantity: parseInt(data2.quantity),
              rate: parseFloat(data2.rate),
              gst: parseInt(data2.gst),
            });
            if (success) {
              toast.success("Purchase Order Updated");
              handleRefresh();
              setEdit(false);
              setData2({});
            }
          } else {
            const [success] = await updateOrder(data2?._id, {
              ...data2,
              quantity: parseInt(data2.quantity),
              rate: parseFloat(data2.rate),
              gst: parseInt(data2.gst),
            });
            if (success) {
              toast.success("Order Updated");
              handleRefresh();
              setEdit(false);
              setData2({});
            }
          }
        }}
      >
        <div className="flex flex-col gap-3">
          <div className="flex justify-between gap-2">
            <div className="border-black font-semibold text-xs">Customer</div>
            <CustomSelect
              width={"256px"}
              onChange={(e) => {
                setData2({
                  ...data2,
                  customerId: e.target.value,
                });
              }}
              options={customers
                ?.filter((item) => item?.type === "Customer")
                ?.map((cust) => ({
                  value: cust._id,
                  label: cust.name,
                }))}
              value={data2.customerId || data2?.customer?._id}
            />
          </div>
          {data2?.paymentType ? (
            <div className="flex justify-between gap-2">
              <div className="border-black font-semibold text-xs">Payment Type</div>
              <CustomSelect
                width={"256px"}
                onChange={(e) => {
                  setData2({
                    ...data2,
                    paymentType: e.target.value,
                  });
                }}
                options={[
                  { value: "Received", label: "Received" },
                  { value: "Payment", label: "Payment" },
                ]}
                value={data2.paymentType}
              />
            </div>
          ) : (
            <>
              <ModalSelect
                title={"GST"}
                value={data2.gst}
                options={["0", "5", "12", "18"]}
                onChange={(e) => {
                  setData2({
                    ...data2,
                    gst: e.target.value,
                  });
                }}
              />
              <ModalInput
                title={"Quantity"}
                value={data2.quantity}
                onChange={(e) => {
                  setData2({
                    ...data2,
                    quantity: e.target.value,
                  });
                }}
              />
              <ModalInput
                title={"Rate"}
                value={data2.rate}
                onChange={(e) => {
                  setData2({
                    ...data2,
                    rate: e.target.value,
                  });
                }}
              />
            </>
          )}
          <ModalInput
            title={"description"}
            value={data2.description}
            onChange={(e) => {
              setData2({
                ...data2,
                description: e.target.value,
              });
            }}
          />
          <ModalInput
            title={"date"}
            type="date"
            value={
              typeof data2?.date === "string" && data2?.date?.split("T")?.[0]
            }
            onChange={(e) => {
              setData2({
                ...data2,
                date: e.target.value,
              });
            }}
          />
          {data2?.paymentType && (
            <ModalInput
              title={"amount"}
              value={data2.amount}
              type={"number"}
              onChange={(e) => {
                setData2({
                  ...data2,
                  amount: e.target.value,
                });
              }}
            />
          )}
        </div>
      </CustomModal>

      {/* Image Attachment & Replacement Modal */}
      {imageModalOpen && (
        <ImageAttachmentModal
          open={imageModalOpen}
          setOpen={setImageModalOpen}
          record={selectedRecordForImage}
          imageField={imageModalField}
          title={imageModalTitle}
          currentImageUrl={currentImageForModal}
          onSuccess={handleRefresh}
        />
      )}
    </div>
  );
};

export default ClientTable;
